export let PanoramaType;(function(a){a[a["CUBE_MAP"]=0]="CUBE_MAP";a[a["SINGLE_IMAGE"]=1]="SINGLE_IMAGE"})(PanoramaType||(PanoramaType={}));